import { gql } from "apollo-boost";

export const VERIFICATION_CODE_SEND = gql`
  mutation send($phoneNumber: String!) {
    verificationCodeSend(phoneNumber: $phoneNumber) {
      status
      message
    }
  }
`;

export const VERIFICATION_CODE_CHECK = gql`
  mutation check($phoneNumber: String!, $code: String!) {
    verificationCodeCheck(phoneNumber: $phoneNumber, code: $code) {
      status
      message
    }
  }
`;

export const REFETCH_USER_PHONE = gql`
  query refetchUserPhone {
    user {
      phone_number
    }
  }
`;